enum PlanType {
	Custom = 'Custom',
	Unlimited = 'Monthly Unlimited',
	Fleet = 'Fleet',
	Pool = 'Pool',
	Coop = 'Co-op',
}

export default PlanType;
